// src/types/wordbookGroup.ts
export enum Visibility {
    VISIBLE = 'VISIBLE',
    HIDDEN = 'HIDDEN',
}

export interface WordbookGroup {
    id: number;
    ownerId?: number;
    ownerName?: string;
    libraryId?: number;
    title: string;
    headLang: string;
    meaningLang: string;
    totalWordbooks: number;
    totalWords: number;
    visibility: Visibility;
    thumbnailUrl?: string;
    deletedAt?: string;
    createdAt: string;
    updatedAt: string;
}

export interface WordbookInGroup {
    id: number;
    title: string;
    headLang: string;
    meaningLang: string;
    totalWords: number;
    visibility: Visibility;
    groupSortOrder: number;
    deletedAt?: string;
    createdAt: string;
}

export interface WordbookGroupDetail extends WordbookGroup {
    ownerEmail?: string;
    wordbooks: WordbookInGroup[] | null;
}
